<script>
    export default {
        name: "RecipeDetailIngredients",
        props: {
            ingredients: Array,
        },
    };
</script>

<template>
    <div class="recipe-detail-ingredients">
        <ul class="recipe-detail-ingredients__list">
            <li
                class="recipe-detail-ingredients__item"
                v-for="(ingredient, index) in ingredients"
                :key="index"
            >
                <span class="recipe-detail-ingredients__value">
                    <span>{{ ingredient.value }}</span>
                </span>
                <span>{{ ingredient.description }}</span>
            </li>
        </ul>
    </div>
</template>

<style lang="scss">
    .recipe-detail-ingredients {
        @include bp($bp-desktop-sm) {
            display: flex;
            flex-direction: column;
            height: 100%;
        }
    }

    .recipe-detail-ingredients__list {
        @include bp($bp-desktop-sm) {
            padding-right: 8px;
        }
    }

    .recipe-detail-ingredients__item {
        display: flex;
        justify-content: space-between;
        font-size: 12px;
        line-height: 14px;
        &:not(:last-child) {
            margin-bottom: 12px;
        }
        @include bp($bp-desktop-sm) {
            font-size: 14px;
            line-height: 26px;
            &:not(:last-child) {
                margin-bottom: 8px;
            }
        }
    }

    .recipe-detail-ingredients__value {
        display: flex;
        flex-grow: 1;
        &::after {
            content: "";
            flex-grow: 1;
            align-self: flex-end;
            height: 1px;
            margin: 0 4px 2px;
            background-color: #e3eef1;
            @include bp($bp-desktop-sm) {
                margin-bottom: 5px;
            }
        }
    }
</style>
